/**
 * AI Repository Interface
 * Handles AI chat interactions with persistent conversation support
 */

export const CONVERSATION_MESSAGE_LIMIT = 20

export interface IAiRepository {
  sendMessage(
    insightId: string,
    message: string,
    context: AiChatContext,
    conversationId?: string,
    options?: { sandbox?: boolean }
  ): Promise<AiResponse>

  getOrCreateConversation(insightId: string, userId: string): Promise<string>

  createNewConversation(
    insightId: string,
    userId: string,
    conversationType?: 'insight' | 'general' | 'sandbox'
  ): Promise<string>

  getConversationMessages(
    conversationId: string
  ): Promise<ConversationMessage[]>

  getConversationUserMessageCount(conversationId: string): Promise<number>

  saveMessage(
    conversationId: string,
    role: 'user' | 'assistant',
    content: string
  ): Promise<void>

  listConversations(
    userId: string,
    conversationType?: 'regular' | 'sandbox'
  ): Promise<ConversationSummary[]>

  deleteConversation(conversationId: string): Promise<void>

  deleteConversations(conversationIds: string[]): Promise<void>
}

export interface AiChatContext {
  ticker?: string
  sentiment?: string
  content?: string
}

export interface AiResponse {
  message: string
  timestamp: Date
}

export interface ConversationMessage {
  id: string
  role: 'user' | 'assistant'
  content: string
  createdAt: string
}

export interface ConversationSummary {
  id: string
  insightId: string
  conversationType: 'insight' | 'general' | 'sandbox'
  ticker?: string
  messageCount: number
  lastMessage?: string
  createdAt: string
  updatedAt: string
}
